<template>
    <div class="sign-up">
        <div class="header">
            <div class="top-bar p-1">
                <div class="left">
                    <div class="logo">
                        <div class="ml-2">
                            <a href="/"><img src="~assets/images/ico-w.png" class="icon" /></a>
                            <a href="/"><img src="~assets/images/logo-w.png" class="logo ml-2 d-none d-lg-inline" /></a>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="flex-row align-items-center justify-content-between h-100 d-none d-lg-block">
                        <span>{{ $t('Non hai un account?') }}</span>
                        <nuxt-link to="/" class="btn btn-brand" style="z-index: 1">
                            {{ $t('Registrati') }}
                        </nuxt-link>
                    </div>
                </div>
                <div class="d-flex w-100 d-lg-none justify-content-center">
                    {{ $t('Log in')}}
                </div>
            </div>
        </div>
        <div class="content">
            <div class="sign-up-container d-flex flex-column justify-content-between align-items-center text-center p-5">
                <div>
                    <h2 class="vanitas">{{ $t('Bentornato.') }} <br /> {{ $t('Accedi al tuo profilo') }}</h2>
                </div>
                <!--<div class="fb-sign-up mt-4">-->
                <!--<button class="btn btn-facebook position-relative">-->
                    <!--<img src="~assets/images/fb-icon.png" />-->
                    <!--{{ $t('Login via Facebook') }}-->
                <!--</button>-->
                <!--</div>-->
                <!--<div class="m-3">-->
                <!--<h4>{{ $t('OR') }}</h4>-->
                <!--</div>-->
                <div class="sign-up-form card w-100 mt-5">
                    <div class="card-body d-flex d-lg-block p-lg-2 p-xl-5 align-items-center justify-content-center">
                        <form @submit.prevent="submit">
                            <div class="row mt-2">
                                <div class="col">
                                    <input class="form-control form-control-lg has-label" name="email" v-validate="'required|email'" :placeholder="$t('indirizzo e-mail')" autocomplete="off" v-model="email" />
                                    <div class="form-error text-danger" v-if="errors.has('email')">{{ errors.first('email') }}</div>
                                </div>
                            </div>

                            <div class="row mt-2">
                                <div class="col">
                                    <input class="form-control form-control-lg has-label" type="password" name="password" v-validate="'required'" :placeholder="$t('Password')" autocomplete="off" v-model="password" />
                                    <div class="form-error text-danger" v-if="errors.has('password')">{{ errors.first('password') }}</div>
                                </div>
                            </div>

                            <div class="d-block d-lg-none w-100 text-left">
                                <input class="mt-3" type="checkbox"/> {{ $t('Ricordami')}}
                            </div>

                            <div class="mt-3">
                                <button class="btn btn-brand btn-lg" @click.prevent="submit" :disabled="processing">
                                    <span v-if="!processing">{{ $t('Accedi') }}</span>
                                    <span v-else><i class="fa fa-spin fa-spinner"></i> {{ $t('Accesso in corso...') }}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="d-block text-center d-block d-lg-none">
                    <nuxt-link to="#">{{ $t('Password dimenticata?')}}</nuxt-link>
                    <br/>
                    {{ $t('Non hai un account?')}}<nuxt-link to="/"> {{ $t('Registrati.')}}</nuxt-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {

        layout: 'blank',

        auth: false,

        middleware: ['redirect-if-authenticated'],

        data() {
            return {
                email: '',
                password: '',
                processing: false
            }
        },

        methods: {
            ...mapActions({
                'login': 'user/login'
            }),
            submit() {

                this.$validator.validate().then(result => {

                    if (!result) return;

                    this.processing = true;

                    this.login({
                            username: this.email,
                            password: this.password
                        })
                        .then(() => this.$router.push('/dashboard'))
                        .catch(() => {

                            this.$notify({
                                group: 'messages',
                                type: 'error',
                                title: this.$t('Le credenziali inserite non risultano essere corrette. Si prega di riprovare.')
                            });

                            this.processing = false;
                        })

                });
            }
        },

        mounted() {

        }
    }
</script>
